export default function ExternalIcon({ ...props }: any) {
  return (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M5.03333 1H1V12H12V7.96667M12 5.21667V1H7.78333" stroke="black" strokeWidth="1.5" />
      <line x1="11.7969" y1="1.53033" x2="5.93026" y2="7.397" strokeWidth="1.5" stroke="black" />
    </svg>
  );
}
